import axios from 'axios'
import gaEvent from 'utilities/tracking'
import { CSRF_HEADERS } from 'globals/constants'
import { setError } from 'containers/Checkout/actions'
import {
  API_PLAN_SELECT_URL,
  GA_EVENT_CATEGORY,
  LOAD_VOUCHER_REQUEST,
  LOAD_VOUCHER_FAILURE,
  LOAD_VOUCHER_SUCCESS,
  PLAN_SET_FIELDS,
  PLAN_SET_ERRORS,
  CLEAR_VOUCHER,
} from './constants'

export const PLAN_SELECT_SUCCESS = 'PLAN_SELECT_SUCCESS'

export function planSelectSuccess(nextStage, plan, voucherCode) {
  return {
    type: PLAN_SELECT_SUCCESS,
    payload: {
      nextStage,
      plan,
      voucher: voucherCode,
    },
  }
}

export function selectPlan(plan, voucherCode) {
  return (dispatch) => {
    const options = {
      headers: { ...CSRF_HEADERS },
    }
    axios
      .post(API_PLAN_SELECT_URL, { id: plan.id, code: voucherCode }, options)
      .then((response) => {
        if (response.data.success) {
          dispatch(planSelectSuccess(response.data.next, plan, voucherCode))
          gaEvent('Success', {
            event_category: GA_EVENT_CATEGORY,
            event_label: voucherCode ? 'Plan select - Use Voucher' : 'Plan select - Selected',
          })
        } else {
          dispatch(setError(true))
          gaEvent('Error', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Plan select - Backend Failure Response',
          })
        }
      })
      .catch((error) => {
        if (error.response && error.response.message) {
          dispatch(setError(error.response.message))
          gaEvent('Error', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Plan select - Backend Failure Response',
          })
        } else {
          dispatch(setError(true))
          gaEvent('Error', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Plan select - Network Error',
          })
        }
      })
  }
}

export const setFieldValues = fields => ({
  type: PLAN_SET_FIELDS,
  payload: fields,
})

export const setFieldErrors = (errors) => {
  Object.keys(errors).forEach((field) => {
    gaEvent('Invalid', {
      event_category: GA_EVENT_CATEGORY,
      event_label: field,
      field_name: field,
      error_message: errors[field],
      non_interaction: true,
    })
  })
  return {
    type: PLAN_SET_ERRORS,
    payload: errors,
  }
}

export const clearVoucher = () => ({
  type: CLEAR_VOUCHER,
})

export const loadVoucherRequest = voucherCode => ({
  type: LOAD_VOUCHER_REQUEST,
  payload: voucherCode,
})

export const loadVoucherFailure = () => ({
  type: LOAD_VOUCHER_FAILURE,
})

export const loadVoucherSuccess = payload => ({
  type: LOAD_VOUCHER_SUCCESS,
  payload,
})

export const loadVoucher = (
  voucherCode,
  errorAction,
) => (dispatch) => {
  dispatch(loadVoucherRequest(voucherCode))
  axios
    .get(`/api/signup/vouchers/${voucherCode}/`)
    .then((data) => {
      dispatch(loadVoucherSuccess(data.data))
    })
    .catch((error) => {
      if (error.response && error.response.data) {
        if (error.response.status === 412) {
          dispatch(loadVoucherFailure())
          if (errorAction) dispatch(errorAction(error.response.data.type))
        } else {
          dispatch(loadVoucherFailure())
          if (errorAction) dispatch(errorAction(error.response.data.code))
        }
      } else {
        dispatch(loadVoucherFailure())
        if (errorAction) { errorAction(['There was an error loading your voucher. Please try again']) }
      }
    })
}



// WEBPACK FOOTER //
// ./containers/stages/PlanSelectionStage/actions.js